import {
  ScannerSortOption,
  enumScannerStatus,
} from '@rematter/frontend-lib-api-client';

import { ScannerRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const scannersListQueryAtom = createQueryAtomFactory(
  'settings.scannersList',
  (params: {
    ids?: string[];
    sidecarId?: string;
    limit?: number;
    offset?: number;
    sorting?: ScannerSortOption[];
  }) => ({
    scanners: {
      __args: {
        filter: {
          ids: params.ids,
          sidecarId: params.sidecarId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        uniqueId: true,
        driverType: true,
        name: true,
        manufacturer: true,
        model: true,
        firmwareVersion: true,
        status: true,
        online: true,
        lastSeenAt: true,
        sidecar: {
          id: true,
          name: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { scanners: ScannerRecord[]; totalCount: number } => {
      if (!data?.scanners?.entries) {
        return { scanners: [], totalCount: 0 };
      }

      return {
        scanners: data.scanners.entries.map((entry) => ({
          id: entry.id,
          sidecarId: entry.sidecarId,
          uniqueId: entry.uniqueId,
          driverType: entry.driverType,
          name: entry.name,
          manufacturer: entry.manufacturer ?? null,
          model: entry.model ?? null,
          firmwareVersion: entry.firmwareVersion ?? null,
          status: entry.status ?? enumScannerStatus.Discovered,
          online: entry.online ?? false,
          lastSeenAt: entry.lastSeenAt
            ? parseZonedDateTime(entry.lastSeenAt)
            : null,
          sidecar: entry.sidecar
            ? {
                id: entry.sidecar.id,
                name: entry.sidecar.name,
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(entry.timestamps.createdAt),
            updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
          },
        })),
        totalCount: data.scanners.page?.total ?? 0,
      };
    },
  },
);
